import gql from "graphql-tag";

export const FRAGMENT_PRODUCT = gql`
  fragment product on Product {
    id
    availableForSale
    compareAtPriceRange {
      minVariantPrice {
        amount
        currencyCode
      }
      maxVariantPrice {
        amount
        currencyCode
      }
    }
    productType
    descriptionHtml
    images(first: 10) {
      edges {
        node {
          id
          url
          altText
          width
          height
        }
      }
    }
    handle
    tags
    title
    priceRange {
      minVariantPrice {
        amount
        currencyCode
      }
      maxVariantPrice {
        amount
        currencyCode
      }
    }
    variants(first: 10) {
      edges {
        node {
          id
          title
          availableForSale
          compareAtPriceV2 {
            amount
            currencyCode
          }
          currentlyNotInStock
          priceV2 {
            amount
            currencyCode
          }
          quantityAvailable
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
`;

// https://shopify.dev/docs/api/usage/search-syntax
export const GET_PRODUCTS_BY_FILTER = gql`
  query getProductsByFilter($filter: String!, $limit: Int = 100) {
    products(first: $limit, query: $filter) {
      nodes {
        ...product
      }
    }
  }
  ${FRAGMENT_PRODUCT}
`;

// https://shopify.dev/docs/api/usage/search-syntax
export const GET_PRODUCTS_BY_FILTER_MULTIPLE = (queries: string[], limit = 100) => gql`
  query getProductsByFilterMultiple {
    ${queries.map(
      (query, i) => `
        product${i}: products(first: ${limit}, query: "${query}") { ...product }
      `
    )}
  }
  ${FRAGMENT_PRODUCT}
`;

export const GET_PRODUCTS_BY_HANDLE = (handles: string[]) => gql`
  query getProductsByHandle {
    ${handles.map(
      handle => `
        product${handle.replace(/-/g, "")}: product(handle: "${handle}") { ...product }
      `
    )}
  }
  ${FRAGMENT_PRODUCT}
`;

export const GET_PRODUCTS_BY_ID = gql`
  query getProductsById($ids: [ID!]!) {
    nodes(ids: $ids) {
      ...product
    }
  }
  ${FRAGMENT_PRODUCT}
`;

// base 64 encoded variant id eg btoa("gid://shopify/ProductVariant/xxxxxxxxx")
export const GET_VARIANT_STOCK_LEVEL = gql`
  query getVariantById($nodeId: ID!) {
    node(id: $nodeId) {
      ... on ProductVariant {
        id
        currentlyNotInStock
        availableForSale
        quantityAvailable
      }
    }
  }
`;
export const PRODUCT_VARIANT_FRAGMENT = gql`
  fragment ProductVariantFragment on ProductVariant {
    id
    title
    price {
      amount
      currencyCode
    }
  }
`;

export const GET_GIFT_CARDS = gql`
  query GetGiftCards {
    products(first: 250, query: "tag:'category--gift-card'") {
      edges {
        node {
          handle
          id
          title
          variants(first: 100) {
            nodes {
              ...ProductVariantFragment
            }
          }
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
  ${PRODUCT_VARIANT_FRAGMENT}
`;
